<template>
  <div class="site-nav-item">
    <a class="site-nav-item__title site-nav-item__title--link" v-if="item.href" :href="item.href" v-html="label"></a>
    <span class="site-nav-item__title" v-else v-html="label"></span>

    <div class="site-nav-item__dropdown">
      <div class="site-nav-item__container">
        <a class="site-nav-item__link" v-for="(subnav, index) in subnavList" :key="`subnav-${index}`"  :href="subnav.href" v-html="subnav.label"></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: Object
  },
  computed: {
    subnavList () {
      return this.item.items
    },
    label () {
      return this.item.label
    }
  }
}
</script>

<style lang="scss" scoped>
.site-nav-item {
  color: $white;
  position: relative;

  &:hover {
    background-color: $theme-red-200;
  }

  &__title {
    cursor: pointer;
    display: flex;
    flex-flow: column;
    height: $header-height;
    justify-content: center;
    padding: 0 10px;

    @include media-breakpoint-up(xl) {
      padding-left: 15px;
      padding-right: 15px;
    }

    &--link {
      color: $white;

      &:hover {
        text-decoration: none;
      }
    }
  }

  &__link {
    background-color: $theme-red-200;
    color: $white;
    display: block;
    transition: background-color 250ms ease;
    white-space: nowrap;

    &:hover {
      background-color: $theme-red-300;
      text-decoration: none;
    }

    .site-nav-item__dropdown & {
      padding: 5px 10px;

      @include media-breakpoint-up(xl) {
        padding-left: 15px;
        padding-right: 15px;
      }
    }
  }

  &__dropdown {
    display: none;
    left: 0;
    max-width: 400px;
    position: absolute;
    top: $header-height;
    z-index: 10;

    :hover > & {
      display: block;
    }
  }

  &__container {
    background: $theme-red-200;
    padding: 12px 0;
  }
}

// .site-nav-item--4762 {
//   width: 123px;
// }

// .site-nav-item--4753 {
//   width: 132px;
// }

// .site-nav-item--4754 {
//   width: 132px;
// }

// .site-nav-item--4763 {
//   width: 132px;
// }

// .site-nav-item--4764 {
//   width: 101px;
// }
</style>
